/**
 * Supabase JS client (browser-side).
 *
 * Created once at module load and shared across the app. Only the
 * anon key is ever exposed here — the service-role key lives on the
 * server in FastAPI.
 */

import { createClient } from "@supabase/supabase-js";

import { env } from "./env";

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "vegr.auth",
  },
});
